/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import './CustomEditCard.css';
import { themes, fonts } from '../../themes/themes';
import { useAppSelector } from '../../../infra/hooks';
import { check_user_permission } from '../../configs/utils';
interface ICustomEditCardProps {
  card_title?: string;
  card_height?: string;
  card_width?: string;
  onClick?: () => void;
  cardToggle?: any;
  showEditButton?: boolean;
  maxHeightForScroll?: string;
  height?: string;
}

//const auth_permissions = useAppSelector((state:any) => state.authPermissionSlice?.authPermission);
const CustomEditCard: React.FC<
  React.PropsWithChildren<ICustomEditCardProps>
> = ({
  children,
  card_title,
  card_height,
  onClick,
  cardToggle = true,
  card_width,
  showEditButton = true,
  maxHeightForScroll = '440px',
  height,
}) => {
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );

  const check_permission = (status: boolean) => {
    return check_user_permission(auth_permissions, status, 'edit');
  };

  return (
    <Box
      className="customEditCard"
      style={{
        height: height ?? 'auto',
        width: 'auto',
        maxWidth: card_width,
        maxHeight: card_height,
        overflowY: 'auto',
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Grid
            item
            xs={10}
            style={{
              justifyContent: 'right',
            }}
          >
            <Typography
              style={{
                color: themes.blackDefault,
                fontSize: fonts.header,
                fontFamily: fonts.fontFamily,
                fontWeight: 'bold',
              }}
            >
              {card_title}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            {check_permission(showEditButton) && (
              <Box className="edit-icon-customEdit">
                {card_title === 'Salary History' ? (
                  cardToggle ? (
                    <i
                      className="las la-angle-up iconPencil"
                      onClick={onClick}
                    />
                  ) : (
                    <i
                      className="las la-angle-down iconPencil"
                      onClick={onClick}
                    />
                  )
                ) : (
                  <i
                    className="las la-pencil-alt iconPencil"
                    onClick={onClick}
                  />
                )}
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Box
        style={{
          maxHeight: maxHeightForScroll,
        }}
        className="edit__card__scrollbar__style"
      >
        <div
          style={{
            padding: '7px',
          }}
        >
          {cardToggle ? children : <></>}
        </div>
      </Box>
    </Box>
  );
};

export default CustomEditCard;
